import React, { useState } from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import NotesAction from './NotesAction';
import DocumentsAction from './DocumentsAction';
import EmailsAction from './EmailsAction';
import HistoryAction from './HistoryAction';

const FastMenu = ({ deal }) => {
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalName) => {
    setActiveModal(modalName);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <>
      {/* Fast Menu Buttons */}
      <div className="d-flex justify-content-end mb-3" style={{ gap: '0.5rem' }}>
        <Button
          color="primary"
          onClick={() => openModal('notes')}
          title="Notes"
          className="shadow-xl"
          style={{
            borderRadius: '2rem',
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            border: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
          }}
        >
          <i className="ni ni-single-copy-04" />
          
        </Button>
        <Button
          color="primary"
          onClick={() => openModal('documents')}
          title="Documents"
          className="shadow-xl"
          style={{
            borderRadius: '2rem',
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            border: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
          }}
        >
          <i className="ni ni-folder-17" />
        </Button>
        <Button
          color="primary"
          onClick={() => openModal('emails')}
          title="Emails"
          className="shadow-xl"
          style={{
            borderRadius: '2rem',
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            border: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
          }}
        >
          <i className="ni ni-email-83" />
        </Button>
        <Button
          color="primary"
          onClick={() => openModal('history')}
          title="History"
          className="shadow-xl"
          style={{
            borderRadius: '2rem',
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            border: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
          }}
        >
          <i className="ni ni-archive-2" />
        </Button>
      </div>

      {/* Modals */}
      <NotesAction
        isOpen={activeModal === 'notes'}
        toggle={closeModal}
        deal={deal}
      />
      <DocumentsAction
        isOpen={activeModal === 'documents'}
        toggle={closeModal}
        deal={deal}
      />
      <EmailsAction
        isOpen={activeModal === 'emails'}
        toggle={closeModal}
        deal={deal}
      />
      <HistoryAction
        isOpen={activeModal === 'history'}
        toggle={closeModal}
        deal={deal}
      />
    </>
  );
};

export default FastMenu;

